module.exports = __webpack_public_path__ + "static/media/dancers-green.db5a577e.png";